import { render } from "./DetailTeacher.vue?vue&type=template&id=79db99aa"
import script from "./DetailTeacher.vue?vue&type=script&lang=js"
export * from "./DetailTeacher.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/teacher/DetailTeacher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79db99aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79db99aa', __exports__)) {
    console.log('reload')
    api.reload('79db99aa', __exports__)
  }
  
  module.hot.accept("./DetailTeacher.vue?vue&type=template&id=79db99aa", () => {
    console.log('re-render')
    api.rerender('79db99aa', render)
  })

}


export default __exports__